import React, {useState} from "react"
import {Button} from "react-bootstrap"
// @ts-ignore
import InputOtp from "@onefifteen-z/react-input-otp";
import {postOTP, postUser} from "../../lib/api";

function LinkDevice(props: { step: number, nextFn: () => void}) {
  const {step, nextFn} = props
  const [OTP, setOTP] = useState<string>('');
  const [error, setError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isNetwork, setIsNetwork] = useState<boolean>(false);

  if (step !== 2) return null;

  function linkDevice(): void {
    if (OTP.length < 5) {
      setErrorMessage("Please enter 5 letters");
      setError(true);
      return;
    }

    setIsNetwork(true);
    postOTP(OTP.toUpperCase())
      .then((response) => {
        if (!response.ok) {
          setError(true);
          setErrorMessage("Please check the code and try again");
          setIsNetwork(false);
          return;
        }

        // @ts-ignore
        postUser({deviceLinked: true})
          .then(response => {
            setIsNetwork(false);
            if (!response.ok) {
              setError(true);
              setErrorMessage("There was an error, please try again");
              return;
            }

            nextFn();
          }).catch(error => {
          setError(true);
          setErrorMessage("There was an error, please try again");
        });
      }).catch(error => {
      console.error(error);
      setError(true);
      setErrorMessage("There was an error, please try again");
    });
  }

  function onChange(value: string): void {
    setError(false);
    setOTP(value.toUpperCase().substr(0,5));
  }

  return (
    <section className="container main p-4 rounded profile-wizard">
      <div className="row">
        <div className="col text-center instructions">
          Let's link your device to your account
          <br/>
          <br/>
          Now open Villa on Meta Quest (tray &gt; 9 dots &gt; Store &gt; Search &gt; Villa),
          <br/>
           grab the 5 letter code and enter it here then click Next
          <br/>
        </div>
      </div>
      <div className="row p-4">
        <div className="col">
          <InputOtp
            wrapperClass="otp-wrapper justify-content-center styles_otpWrapper__ZaQlv"
            inputClass="otp-input styles_otpInput__2umfM"
            errorMessageClass="otp-error styles_errorMessage__1sjan"
            type="text"
            otpLength={5}
            onChange={onChange}
            value={OTP}
            error={error}
            style={{textTransform:"uppercase"}}
            errorMessage={errorMessage}
            disabled={isNetwork}
            autoFocus
          />
        </div>
      </div>
      <div className="row py-3">
        <div className="col text-center">
          <Button
            className="btn-50 next"
            onClick={linkDevice}
            variant="primary"
            disabled={isNetwork}
          >
            Next
          </Button>
        </div>
      </div>
    </section>
  );
}

export default LinkDevice;
